import get from 'lodash/get'

const DEFAULT_GROUP = { name: '', items: [{ name: '', items: [{ name: '' }] }] }
const DEFAULT_TIER = { name: '', items: [{ name: '' }] }
const DEFAULT_CATEGORY = { name: '' }

const clone = item => JSON.parse(JSON.stringify(item))
const getBranch = (state, groupIndex, tierIndex) => {
  return get(
    state,
    `tree[${groupIndex}].items[${tierIndex}].items`,
    get(state, `tree[${typeof (tierIndex) === 'number' ? tierIndex : groupIndex}].items`, state.tree)
  )
}

const createRules = (items, depth = 1, indexes) => {
  const rules = []
  items.forEach(item => {
    const rule = {
      name: [{
        required: true,
        message: 'Field name is required',
      }],
    }
    if (item.items) rule.items = createRules(item.items)
    rules.push(rule)
  })
  return rules
}

const state = {
  tree: [{ name: '', items: [{ name: '', items: [{ name: '' }] }] }],
}

const getters = {
  dynamicRules: s => createRules(s.tree),
}

const mutations = {
  SET_TREE(state, payload) {
    state.tree = payload
  },
  RESET_TREE(state, type) {
    switch (type) {
      case 'groups':
        state.tree = [clone(DEFAULT_GROUP)]
        break
      case 'tiers':
        state.tree = [clone(DEFAULT_TIER)]
        break
      default:
        state.tree = [clone(DEFAULT_CATEGORY)]
        break
    }
  },
  ADD_ITEM(state, { itemType, groupIndex, tierIndex }) {
    const branch = getBranch(state, groupIndex, tierIndex)
    switch (itemType) {
      case 'group':
        branch.push(clone(DEFAULT_GROUP))
        break
      case 'tier':
        branch.push(clone(DEFAULT_TIER))
        break
      case 'category':
        branch.push(clone(DEFAULT_CATEGORY))
        break
    }
  },
  REMOVE_ITEM(state, { groupIndex, tierIndex, index }) {
    const branch = getBranch(state, groupIndex, tierIndex)
    branch.splice(index, 1)
  },
  SORT_ITEM(state, { oldIndex, newIndex, groupIndex, tierIndex }) {
    const branch = getBranch(state, groupIndex, tierIndex)
    branch.splice(newIndex, 0, branch.splice(oldIndex, 1)[0])
  },
}

const actions = {
  storeTree({ commit }, payload) {
    commit('SET_TREE', payload)
  },
  switchType({ commit }, type) {
    commit('RESET_TREE', type)
  },
  addItem({ commit }, payload) {
    commit('ADD_ITEM', payload)
  },
  removeItem({ commit }, payload) {
    commit('REMOVE_ITEM', payload)
  },
  sortItem({ commit }, payload) {
    commit('SORT_ITEM', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
